/** @file Evaluates a compiled curve segment (0 linear, 1 stepped, 2 bezier) between two values. */
import { evalCubicBezier } from '@pose2d/math/bezier';
import { lerp } from '@pose2d/math/lerp';

/** Control numbers per segment in CurveTable.cp: x1, cy1, x2, cy2. */
const CP_STRIDE = 4;

/** Returns the interpolated value at normalized time u for segment seg of a curve table. */
export function evalCurve(kind: Uint8Array, cp: Float64Array, seg: number, v0: number, v1: number, u: number): number {
  const k = kind[seg] ?? 0;
  if (k === 1) return v0;
  if (k === 2) {
    const o = seg * CP_STRIDE;
    return evalCubicBezier(cp[o] ?? 0, cp[o + 1] ?? v0, cp[o + 2] ?? 1, cp[o + 3] ?? v1, v0, v1, u);
  }
  return lerp(v0, v1, u);
}
